import React, { Component } from 'react'
import Loading from './Loading.js';

import InfiniteScroll from "react-infinite-scroll-component";
import MovieIteam from './MovieIteam.js';


export default class Movie extends Component {

  constructor(props) {
    // first execute..
    super(props);
    // must be super call
    this.state = {
      results: [],
      loading: true,
      page: 1,
      totalResults: 0
    }
  }



  async componentDidMount(props) {
    // console.log("before api call")
    this.props.setProgress(10);
    let url = `https://api.themoviedb.org/3/discover/movie?sort_by=popularity.desc&page=${this.state.page}&api_key=a6a7c07afdab9fe613b5fbf0c0c08062`;
    let data = await fetch(url);
    this.props.setProgress(70);

    let parseData = await data.json();
    // console.log(parseData);
    this.setState({ results: parseData.results, totalResults: parseData.totalResults, loading: false });
    this.props.setProgress(100);

  }



  fetchMoreData = async () => {

    this.setState({
      page: this.state.page + 1,
      loading: true
    })
    let url = `https://api.themoviedb.org/3/discover/movie?sort_by=popularity.desc&page=${this.state.page}&api_key=a6a7c07afdab9fe613b5fbf0c0c08062`;
    let data = await fetch(url);
    let parseData = await data.json();
    this.setState({
      results: this.state.results.concat(parseData.results),
      loading: false,
      totalResults: this.state.totalResults
    });


  };

  render() {
    // second execute..
    return (
      <>
        <div className="text-center my-3">

          <h1><b> MovieBucket - Top Movie! </b></h1>
          {this.state.loading && <Loading></Loading>}
        </div>


        <InfiniteScroll
          dataLength={this.state.results.length}
          next={this.fetchMoreData}
          hasMore={true}

          loader={<Loading />}
        >
          <div className='container my-4'>
            <div className="row">
              {this.state.results.map((element) => {

                return <div className="col-md-4" key={element.id}>
                  <MovieIteam urlId={"https://www.themoviedb.org/movie/" + element.id} imdb={element.vote_average} release_date={element.release_date} title={element.title} overview={element.overview.slice(0, 120)} imageurl={"https://image.tmdb.org/t/p/w500" + element.poster_path}></MovieIteam>
                </div>
              })}

            </div>
          </div>
        </InfiniteScroll>

      </>
    )
  }
}

